export default __webpack_public_path__ + "img/arrow-left.2691690.svg";